import { getQuery } from '@/utils/utils'
import { getEnv } from '@/utils/env'
import { getUvid } from '@/utils/uvid'
import { isObj } from '@/utils/tool'

// 详情页是否显示fb home page
export function detailPageShowFacebookHomepage() {
  const source = getQuery('source')
  if (source && source === 'SPT2' && getEnv() === 'test') {
    return true
  }
  if (window.abtest_showFbHomepage) {
    return true
  }
  return false
}

// pubgm 是否显示折扣bar
export function pubgmShowDiscountBar() {
  // const discount = getQuery('discount')
  // if (discount && discount === '1' && getEnv() === 'test') {
  //   return true
  // }
  // if (window.abtest_showDiscountBar) {
  //   return true
  // }
  // return false
  return true
}

// lm 游戏显示可折叠的购买提示
export function lmPurchaseRules() {
  // const lmRules = getQuery('lmRules')
  // if (lmRules && lmRules === '1' && getEnv() === 'test') {
  //   return true
  // }
  // if (window.abtest_lordsmobile_purchase) {
  //   return true
  // }
  // return false
  return true
}

// ru pubgm 钱包AAB测试活动，abtest_pubgm_wallet_potision = 1的时候钱包放第一位
export function pubgm_wallet_position() {
  const source = getQuery('source')
  if (source && source === 'wallet' && getEnv() === 'test') {
    return true
  }
  if (window.abtest_pubgm_wallet_potision * 1 === 1) {
    return true
  }
  if (window.abtest_pubgm_wallet_potision * 1 === 2) {
    return false
  }
  return false
}

// ru pubgm 支付栏显示 vip 点数 A/B 测试，uvid尾号为 0-4 的显示，否则不显示
export function vipPointsWillShow() {
  const uvid = getUvid()
  if (uvid === 'anonymous') {
    return true
  } else {
    const lastChar = uvid.slice(-1)
    return 0 <= lastChar && lastChar <= 4
  }
}

// id mlbb
// window.idMlbbBannerAB { isInProcess: true or false, banner: '' }
// isInProcess true实验中 false实验结束
export function idMlbbActBannerAB() {
  if (
    !(
      window &&
      isObj(window.idMlbbBannerAB) &&
      Object.keys(window.idMlbbBannerAB).length &&
      window.idMlbbBannerAB?.isInProcess
    )
  ) {
    return {}
  }
  const { banner = '' } = window.idMlbbBannerAB || {}
  const useReg = new RegExp(/.*[147]$/)
  const uvid = getUvid() || ''
  const isHit = !!(useReg.test(uvid) && banner)
  const bannerImg = banner
  const actId = `${process.env.VUE_APP_ENV_TYPE === 'develop' ? 1378 : 25}`
  return {
    isHit,
    bannerImg,
    actId,
  }
}

// my-mlbb 马来mlbb uvid末位0-1，0-4
// window.myMlbbDynamicBanner { stage: 0 or 1 or 2, banner: '' }
// stage 0:不进行实验 1:末位0-1为实验组 2:末位0-4为实验组
export function myMlbbDynamicBannerAB() {
  if (
    !(
      window &&
      isObj(window.myMlbbDynamicBanner) &&
      Object.keys(window.myMlbbDynamicBanner).length &&
      window.myMlbbDynamicBanner.stage
    )
  ) {
    return {}
  }
  const { stage = 0, banner = '' } = window.myMlbbDynamicBanner || {}
  const stage_1 = new RegExp(/.*[0-1]$/)
  const stage_2 = new RegExp(/.*[0-4]$/)
  const uvid = getUvid() || ''
  let isHit = false
  let bannerImg = ''
  const useReg = stage === 1 ? stage_1 : stage === 2 ? stage_2 : null
  isHit = useReg ? useReg.test(uvid) : false
  isHit = !!(isHit && banner)
  bannerImg = banner
  return {
    isHit,
    bannerImg,
  }
}
